import React from "react";
import "./ETHMX2025.css";

function ETHMX2025() {

  return (
    <div className="ETHMX2025-wrapper">
      <iframe
      src="https://tally.so/r/nP49NV?transparentBackground=1"
      width="100%"
      height="100%"
      frameBorder="0"
      title="Ethereum México 2025 - Monterrey"
    ></iframe>

    </div>
  );
}

export default ETHMX2025;
